// @flow

export const STREAM_GOVERNANCE_SUMMARY_GRID_ENABLED_BACKEND_NAME = 'is_sg_enabled';
export const STREAM_GOVERNANCE_SUMMARY_GRID_TOTAL_SPEND_AT_LIST = 'Total Spend (List)';
export const STREAM_GOVERNANCE_SUMMARY_GRID_TOTAL_SPEND_AT_LIST_BACKEND_NAME = 'total_spend';
export const STREAM_GOVERNANCE_SUMMARY_GRID_TOTAL_SPEND_DISCOUNTED = 'Total Spend (Disc)';
export const STREAM_GOVERNANCE_SUMMARY_GRID_TOTAL_SPEND_DISCOUNTED_BACKEND_NAME =
  'total_spend_discounted';
